module.exports = __webpack_public_path__ + "img/local_airport.4efe563f.svg";